<template>
  <div>
    <!-- Modal for ETD Notification -->
    <modal :show.sync="modals.etdNotification" type="large">
      <h2
        slot="header"
        class="modal-title text-center"
        id="modal-title-default"
      >
        Maintenance Notification
      </h2>
      <div class="row">
        <card>
          <el-table
            :data="tableReminder"
            :row-class-name="tableRowClassReminder"
            height="300"
            :header-cell-style="{ background: 'transparent', border: 'none', borderBottom: '0.5px solid #3d3f51' }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              label="Asset No"
              min-width="120"
              prop="AssetNo"
              align="center"
            ></el-table-column>
            <el-table-column
              label="Asset Description"
              min-width="120"
              prop="AssetDesc"
              align="center"
            ></el-table-column>
            <el-table-column
              label="Next Maintenance Date"
              min-width="150"
              prop="NextMaintenanceDate"
              align="center"
            ></el-table-column>
          </el-table>
        </card>
      </div>
    </modal>
    <div class="row">
      <div class="col-lg-12">
        <h4>
          Select Site:
          <el-select
            class="select-primary tab"
            placeholder="Single Select"
            v-model="selects.selectSite"
            @change="filterSite()"
          >
            <el-option
              v-for="option in selects.site"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg">
            <stats-card
              :title="card.titleTotalAsset"
              :subTitle="card.subTitleTotalAsset"
              :icon="card.iconTotalAsset"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerTotalAsset"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titleDHESAsset"
              :subTitle="card.subTitleDHESAsset"
              :icon="card.iconDHESAsset"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerDHESAsset"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <stats-card
              :title="card.titleContractor"
              :subTitle="card.subTitleContractor"
              :icon="card.iconContractor"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerContractor"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titlePPMDone"
              :subTitle="card.subTitlePPMDone"
              :icon="card.iconPPMDone"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerPPMDone"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg" >
            <stats-card
              :title="card.titleUndermaintenance"
              :subTitle="card.subTitleUndermaintenance"
              :icon="card.iconUndermaintenance"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerUndermaintenance"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titlePPMOverdue"
              :subTitle="card.subTitlePPMOverdue"
              :icon="card.iconPPMOverdue"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerPPMOverdue"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg">
            <stats-card
              :title="card.titleBreakdown"
              :subTitle="card.subTitleBreakdown"
              :icon="card.iconBreakdown"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerBreakdown"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titleUnderrepair"
              :subTitle="card.subTitleUnderrepair"
              :icon="card.iconUnderrepair"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerUnderrepair"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <stats-card
              :title="card.titleProposedber"
              :subTitle="card.subTitleProposedber"
              :icon="card.iconProposedber"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerProposedber"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titleAvailable"
              :subTitle="card.subTitleAvailable"
              :icon="card.iconAvailable"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerAvailable"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
          <div class="col-lg">
            <stats-card
              :title="card.titleOperational"
              :subTitle="card.subTitleOperational"
              :icon="card.iconOperational"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="card.footerOperational"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-lg">
        <div class="row">
          <div class="col-lg" v-for="card in statsCard1" :key="card.subTitle">
            <stats-card
              :title="card.title"
              :subTitle="card.subTitle"
              :icon="card.icon"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div class="footer-font" slot="footer" v-html="card.footer" style="color:#99e6ff"></div>
            </stats-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <div class="row">
          <div class="col-lg" v-for="card in statsCard2" :key="card.subTitle">
            <stats-card
              :title="card.title"
              :subTitle="card.subTitle"
              :icon="card.icon"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div class="footer-font" slot="footer" v-html="card.footer" style="color:#99e6ff"></div>
            </stats-card>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-3 d-flex">
        <card class="card-chart card-chart-pie">
          <template slot="header">
            <h3 class="card-title">
              <b>Asset Ownership</b>
            </h3>
          </template>

          <div class="chart-area">
            <pie-chart
              v-if="assetOwnership.loaded"
              :chart-data="assetOwnership.chartData"
              :extra-options="assetOwnership.extraOptions"
              :height="220"
            ></pie-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!assetOwnership.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-2 d-flex">
        <card>
          <h4 class="card-title">Asset Percentage</h4>
          <base-progress
            label="AFES Asset"
            :value="percent.dhesAsset"
            value-position="right"
            type="blue"
          />
          <base-progress
            label="Contractor Asset"
            :value="percent.contractorAsset"
            value-position="right"
            type="white"
          />
          <base-progress
            label="PPM Done"
            :value="percent.ppmDone"
            value-position="right"
            type="green"
          />
          <base-progress
            label="Under-Maintenance"
            :value="percent.ppmMaintain"
            value-position="right"
            type="yellow"
          />
          <base-progress
            label="PPM Overdue"
            :value="percent.ppmDue"
            value-position="right"
            type="magenta"
          />
          <base-progress
            label="Asset Utilization"
            :value="percent.utilization"
            value-position="right"
            type="blue"
          />
          <base-progress
            label="Breakdown"
            :value="percent.breakdown"
            value-position="right"
            type="white"
          />
          <base-progress
            label="Under-Repair"
            :value="percent.underrepair"
            value-position="right"
            type="green"
          />
          <base-progress
            label="Proposed-BER"
            :value="percent.proposedber"
            value-position="right"
            type="yellow"
          />
          <base-progress
            label="Available"
            :value="percent.available"
            value-position="right"
            type="red"
          />
        </card>
      </div>
      <div class="col-md-7 d-flex">
        <card card-body-classes="table-full-width">
          <!-- <h4 slot="header" class="card-title">List of Under-maintenance Asset</h4> -->
          <template slot="header">
            <h3 class="card-title">
              <!-- <i class="tim-icons icon-chart-bar-32 text-info"></i> -->
              <b>Asset Under-maintenance</b>
            </h3>
          </template>
          <el-table
            :data="tableData"
            height="350"
            :row-class-name="tableRowClassName"
            :header-cell-style="{ background: 'transparent', border: 'none', borderBottom: '0.5px solid #3d3f51' }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Asset Description"
              property="AssetDesc"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Site"
              align="center"
              property="SiteName"
            ></el-table-column>
            <el-table-column
              min-width="180"
              sortable
              label="Estimated Maintenance Date"
              align="center"
              property="NextMaintenanceDate"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Status"
              property="StatusName"
            ></el-table-column>
          </el-table>
        </card>
      </div>

      <div class="col-md-3 d-flex">
        <card class="card-chart card-chart-pie">
          <template slot="header">
            <h3 class="card-title">
              <b>PPM status</b>
            </h3>
          </template>

          <div class="chart-area">
            <pie-chart
              v-if="ppmStatus.loaded"
              :chart-data="ppmStatus.chartData"
              :extra-options="ppmStatus.extraOptions"
              :height="220"
            ></pie-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!ppmStatus.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-9 d-flex">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Asset Utilization of this month</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="utilizationGraph.loaded"
              :chart-data="utilizationGraph.chartData"
              :gradient-colors="utilizationGraph.gradientColors"
              :gradient-stops="utilizationGraph.gradientStops"
              :extra-options="utilizationGraph.extraOptions"
              :height="250"
            ></line-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!utilizationGraph.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  TabPane,
  Tabs,
  Collapse,
  CollapseItem,
  BaseProgress,
  Modal,
  BaseSwitch,
  BaseCheckbox,
} from "src/components";
import { Table, TableColumn, DatePicker, Select, Option } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";

import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";

import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  components: {
    Loading,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BaseProgress,
    PieChart,
    LineChart,
    Modal,
    BaseSwitch,
    BaseCheckbox,
    Circle8,
  },
  data() {
    return {
      card: {
        // total asset
        titleTotalAsset: "0",
        iconTotalAsset: require("@/assets/img/asset_total.png"),
        footerTotalAsset: "Total Assets",
        // DHES asset
        titleDHESAsset: "0",
        iconDHESAsset: require("@/assets/img/asset_total_DHES.png"),
        footerDHESAsset: "AFES Asset",
        // Contractor asset
        titleContractor: "0",
        iconContractor: require("@/assets/img/asset_total_contractor.png"),
        footerContractor: "Contractor Asset",
        // PPM Done
        titlePPMDone: "0",
        iconPPMDone: require("@/assets/img/Done.png"),
        footerPPMDone: "PPM Done",
        // PPM Under-maintenance
        titleUndermaintenance: "0",
        iconUndermaintenance: require("@/assets/img/service_maintenance.png"),
        footerUndermaintenance: "Under-maintenance",
        // PPM Overdue
        titlePPMOverdue: "0",
        iconPPMOverdue: require("@/assets/img/overdue.png"),
        footerPPMOverdue: "PPM Overdue",
        // Breakdown
        titleBreakdown: "0",
        iconBreakdown: require("@/assets/img/breakdown.png"),
        footerBreakdown: "Breakdown",
        // Under-repair
        titleUnderrepair: "0",
        iconUnderrepair: require("@/assets/img/service_maintenance.png"),
        footerUnderrepair: "Under-Repair",
        // Proposed-BER
        titleProposedber: "0",
        iconProposedber: require("@/assets/img/Non-repairable .png"),
        footerProposedber: "Proposed-BER",
        // Available
        titleAvailable: "0",
        iconAvailable: require("@/assets/img/Done.png"),
        footerAvailable: "Available",
        // Operational
        titleOperational: "0",
        iconOperational: require("@/assets/img/operational.png"),
        footerOperational: "Operational",
      },
      modals: {
        etdNotification: false,
      },
      percent: {
        dhesAsset: 0,
        contractorAsset: 0,
        ppmDone: 0,
        ppmMaintain: 0,
        ppmDue: 0,
        utilization: 0,
        breakdown: 0,
        underrepair: 0,
        proposedber: 0,
        available: 0,
      },
      tableReminder: [],
      tableETD: [
        {
          id: 1,
          vehicleNo: "DHES 12",
          vehicleDispatchDate: "10/12/2019",
          datePicker: "2020/01/29",
        },
        {
          id: 1,
          vehicleNo: "DHES 12",
          vehicleDispatchDate: "10/12/2019",
          datePicker: "2020/01/25",
        },
      ],
      utilizationGraph: {
        chartData: {
          labels: [...Array(30).keys()].map((x) => ++x + "th"),
          datasets: [
            {
              label: "Asset Utilization",
              fill: true,
              borderColor: "rgba(211, 244, 255, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(211, 244, 255, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: Array(30)
                .fill()
                .map(() => Math.round(Math.random() * 100)),
            },
          ],
        },
        extraOptions: chartConfigs.percentChartOptions,
        gradientColors: [
          "rgba(211, 244, 255, 0.8)",
          "rgba(211, 244, 255, 0.3)",
          "rgba(211, 244, 255, 0.0)",
        ],
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      // Pie Chart
      assetOwnership: {
        chartData: {
          labels: ["AFES", "Contractor"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#336fb6", "#f9f6f7"],
              borderWidth: 0,
              data: [60, 40],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
        loaded: false,
      },
      // Pie Chart
      ppmStatus: {
        chartData: {
          labels: ["Done", "Under Maintenance", "Overdue"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#84eb3d", "#fcf305", "red"],
              borderWidth: 0,
              data: [60, 40, 20],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
        loaded: false,
      },
      tableData: [],
      // statsCard1: [
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/asset_total.png"),
      //     footer: "Total Assets"
      //   },
      //   {
      //     title: "0",
      //     // subTitle: "Total/Percentage",
      //     icon: require("@/assets/img/asset_total_DHES.png"),
      //     footer: "DHES Asset"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/asset_total_contractor.png"),
      //     footer: "Contractor Asset"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/breakdown.png"),
      //     footer: "Breakdown"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/service_maintenance.png"),
      //     footer: "Under-Repair"
      //   }
      // ],
      // statsCard2: [
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/Done.png"),
      //     footer: "PPM done"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/service_maintenance.png"),
      //     footer: "Under-maintenance"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/overdue.png"),
      //     footer: "PPM overdue"
      //   },

      //   {
      //     title: "0",
      //     icon: require("@/assets/img/Non-repairable .png"),
      //     footer: "Proposed-BER"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/Done.png"),
      //     footer: "Available"
      //   },
      //   {
      //     title: "0",
      //     icon: require("@/assets/img/operational.png"),
      //     footer: "Operational"
      //   }
      // ],
      selects: {
        selectSite: "",
        site: [{ value: "*", label: "All" }],
        complete: [
          { value: "Complete", label: "Complete" },
          { value: "Not Complete", label: "Not Complete" },
        ],
      },
    };
  },

  created() {
    this.selects.selectSite = this.selects.site[0].value;
    this.getReminder();

    this.getSocketData();

    //temp worker
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },

  methods: {
    tableRowClassName({ rowIndex }) {
      let currentETD = moment(this.tableData[rowIndex].NextMaintenanceDate);

      if (currentETD < moment.now()) {
        return "table-red";
      }
      return "";
    },
    tableRowClassReminder({ rowIndex }) {
      if (this.tableReminder[rowIndex].IsDue === 1) {
        return "table-red";
      }
      return "";
    },
    getReminder() {
      this.$http.get(":9996/api/v1/mobile/reminder").then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          if (data.length != 0) {
            // this.modals.etdNotification = true;
            this.modals.etdNotification = false;
            this.tableReminder = data;
          }
        }
      });
    },
    filterSite() {
      this.socket.close();
      this.utilizationGraph.loaded = false;
      this.ppmStatus.loaded = false;
      this.assetOwnership.loaded = false;
      this.getSocketData();
    },
    getSocketData() {
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9996/api/v1/overview/ADMIN_VIEW/ws"
      );

      this.socket.onopen = () => {
        this.status = "connected";
        let currentFilter = [this.selects.selectSite];
        this.socket.send(currentFilter);
        this.isLoading = true;
      };

      this.socket.onmessage = ({ data }) => {
        console.log(this.selects.selectSite);
        this.parseData(data);
      };

      return this.socket;
    },
    parseData(data) {
      this.selects.site = [{ value: "*", label: "All" }];
      this.utilizationGraph.loaded = false;
      this.ppmStatus.loaded = false;
      this.assetOwnership.loaded = false;
      console.log("CALLED PARSE");
      console.log(data);
      let jsonData = JSON.parse(data);
      console.log(jsonData);
      // ################# FILTER ################# //
      let filter = jsonData.Filter;

      for (let i = 0; i < filter.length; i++) {
        let siteFilter = {
          value: filter[i].SiteID,
          label: filter[i].SiteName,
        };
        this.selects.site.push(siteFilter);
      }

      // ################# CARD ################# //
      // console.log(jsonData.Card.AssetUtilization)
      // this.statsCard1[0].title = jsonData.Card.TotalAsset.toString();
      // // this.percent.utilization = jsonData.Card.AssetUtilization.toString();
      // this.statsCard1[1].title = jsonData.Card.DhesAsset.toString();
      // this.statsCard1[2].title = jsonData.Card.ContractorAsset.toString();
      // this.statsCard1[3].title = jsonData.Card.PpmDone.toString();
      // this.statsCard1[4].title = jsonData.Card.PpmMaintenance.toString();
      // this.statsCard2[0].title = jsonData.Card.PpmOverdue.toString();
      // this.statsCard2[1].title = jsonData.Card.Breakdown.toString();
      // this.statsCard2[2].title = jsonData.Card.UnderRepair.toString();
      // this.statsCard2[3].title = jsonData.Card.ProposedBer.toString();
      // this.statsCard2[4].title = jsonData.Card.NonOperational.toString();

      this.card = {
        // total assets
        titleTotalAsset: jsonData.Card.TotalAsset.toString(),
        iconTotalAsset: require("@/assets/img/asset_total.png"),
        footerTotalAsset: "Total Assets",
        // DHES asset
        titleDHESAsset: jsonData.Card.DhesAsset.toString(),
        iconDHESAsset: require("@/assets/img/asset_total_DHES.png"),
        footerDHESAsset: "AFES Asset",
        // Contractor asset
        titleContractor: jsonData.Card.ContractorAsset.toString(),
        iconContractor: require("@/assets/img/asset_total_contractor.png"),
        footerContractor: "Contractor Asset",
        // PPM Done
        titlePPMDone: jsonData.Card.PpmDone.toString(),
        iconPPMDone: require("@/assets/img/Done.png"),
        footerPPMDone: "PPM Done",
        // PPM Under-maintenance
        titleUndermaintenance: jsonData.Card.PpmMaintenance.toString(),
        iconUndermaintenance: require("@/assets/img/service_maintenance.png"),
        footerUndermaintenance: "Under-maintenance",
        // PPM Overdue
        titlePPMOverdue: jsonData.Card.PpmOverdue.toString(),
        iconPPMOverdue: require("@/assets/img/overdue.png"),
        footerPPMOverdue: "PPM Overdue",
        // Breakdown
        titleBreakdown: jsonData.Card.Breakdown.toString(),
        iconBreakdown: require("@/assets/img/breakdown.png"),
        footerBreakdown: "Breakdown",
        // Under-repair
        titleUnderrepair: jsonData.Card.UnderRepair.toString(),
        iconUnderrepair: require("@/assets/img/service_maintenance.png"),
        footerUnderrepair: "Under-Repair",
        // Proposed-BER
        titleProposedber: jsonData.Card.ProposedBer.toString(),
        iconProposedber: require("@/assets/img/Non-repairable .png"),
        footerProposedber: "Proposed-BER",
        // Available
        titleAvailable: jsonData.Card.NonOperational.toString(),
        iconAvailable: require("@/assets/img/Done.png"),
        footerAvailable: "Available",
        // Operational
        titleOperational: jsonData.Card.Operational.toString(),
        iconOperational: require("@/assets/img/operational.png"),
        footerOperational: "Operational",
      };

      // ################# ASSET PERCENTAGE ################# //

      this.percent.dhesAsset = parseFloat(
        ((jsonData.Card.DhesAsset / jsonData.Card.TotalAsset) * 100).toFixed(2)
      );

      this.percent.contractorAsset = parseFloat(
        (
          (jsonData.Card.ContractorAsset / jsonData.Card.TotalAsset) *
          100
        ).toFixed(2)
      );

      this.percent.ppmDone = parseFloat(
        ((jsonData.Card.PpmDone / jsonData.Card.TotalAsset) * 100).toFixed(2)
      );

      this.percent.ppmMaintain = parseFloat(
        (
          (jsonData.Card.PpmMaintenance / jsonData.Card.TotalAsset) *
          100
        ).toFixed(2)
      );

      this.percent.ppmDue = parseFloat(
        ((jsonData.Card.PpmOverdue / jsonData.Card.TotalAsset) * 100).toFixed(2)
      );

      this.percent.utilization = parseFloat(
        jsonData.Card.AssetUtilization
      ).toFixed(2);

      this.percent.breakdown = parseFloat(
        ((jsonData.Card.Breakdown / jsonData.Card.TotalAsset) * 100).toFixed(2)
      );

      this.percent.underrepair = parseFloat(
        ((jsonData.Card.UnderRepair / jsonData.Card.TotalAsset) * 100).toFixed(
          2
        )
      );

      this.percent.proposedber = parseFloat(
        ((jsonData.Card.ProposedBer / jsonData.Card.TotalAsset) * 100).toFixed(
          2
        )
      );

      this.percent.available = parseFloat(
        (
          (jsonData.Card.NonOperational / jsonData.Card.TotalAsset) *
          100
        ).toFixed(2)
      );

      if (jsonData.Card.TotalAsset == 0) {
        this.percent.available = parseFloat(0).toFixed(2);
        this.percent.proposedber = parseFloat(0).toFixed(2);
        this.percent.underrepair = parseFloat(0).toFixed(2);
        this.percent.breakdown = parseFloat(0).toFixed(2);
        this.percent.ppmDue = parseFloat(0).toFixed(2);
        this.percent.ppmMaintain = parseFloat(0).toFixed(2);
        this.percent.ppmDone = parseFloat(0).toFixed(2);
        this.percent.contractorAsset = parseFloat(0).toFixed(2);
        this.percent.dhesAsset = parseFloat(0).toFixed(2);
      }

      // ################# ASSET OWNERSHIP ################# //
      let newAssetOwner = {
        chartData: {
          labels: ["AFES", "Contractor"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#336fb6", "#f9f6f7"],
              borderWidth: 0,
              data: [jsonData.Card.DhesAsset, jsonData.Card.ContractorAsset],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
        loaded: true,
      };

      this.assetOwnership = newAssetOwner;

      // ################# PPM STATUS ################# //
      let newPPMStatus = {
        chartData: {
          labels: ["Done", "Under Maintenance", "Overdue"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#84eb3d", "#fcf305", "red"],
              borderWidth: 0,
              data: [
                jsonData.Card.PpmDone,
                jsonData.Card.PpmMaintenance,
                jsonData.Card.PpmOverdue,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
        loaded: true,
      };

      this.ppmStatus = newPPMStatus;

      // ################# ASSET UTILIZATION ################# //

      let graph = jsonData.Graph;
      let timeStamp = [];
      let utilData = [];

      for (let i = 0; i < graph.length; i++) {
        timeStamp.push(moment(graph[i].Date).format("YYYY-MM-DD"));
        utilData.push(graph[i].AssetUtilization);
      }

      this.updateGraph(timeStamp, utilData);

      // ################# TABLE ################# //
      console.log(jsonData.table);
      this.tableData = jsonData.table;
    },

    async updateGraph(timeStamp, data) {
      let newAssetUtil = await {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Asset Utilization",
              fill: true,
              borderColor: "rgba(211, 244, 255, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(211, 244, 255, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: data,
            },
          ],
        },
        extraOptions: chartConfigs.percentChartOptions,
        gradientColors: [
          "rgba(211, 244, 255, 0.8)",
          "rgba(211, 244, 255, 0.3)",
          "rgba(211, 244, 255, 0.0)",
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };
      console.log(newAssetUtil);
      this.utilizationGraph = newAssetUtil;
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 110%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
.spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
